export const reportOrdersHeader = [
  { value: "invoice_id", text: "Invoice" },
  { value: "status", text: "Status" },
  { value: "source", text: "Channel" },
  { value: "partner_order_id", text: "Order Id" },
  { value: "rider_status", innerValue: "name", text: "Rider" },
  { value: "rider_status", innerValue: "phone", text: "Rider Mob" },
  { value: "payable_amount", text: "Amount" },
  { value: "mode", text: "Collected" }
];

export const itemWiseSalesHeaderForPdf = [
  { value: "name", text: "Item Name" },
  { value: "total", text: "Total Sale" },
  { value: "revenue", text: "Revenue Contribution" }
];
export const itemWiseSalesHeaderForExcel = [
  { value: "name", innerValue: "label", text: "Item Name" },
  { value: "name", innerValue: "amount", text: "Unit Price" },
  { value: "total", innerValue: "label", text: "Total Sale" },
  { value: "total", innerValue: "amount", text: "Total Sale Amount" },
  { value: "revenue", text: "Revenue Contribution" }
];
export const summaryReportHeader = [
  { value: "channel", label: "Channel", key: "channel" },
  { value: "orders", label: "Orders", key: "count" },
  { value: "grossSale", label: "Gross Sale", key: "billable_amount" },
  { value: "tax", label: "Tax", key: "total_taxes" },
  { value: "merchDiscount", label: "Merch. Discount", key: "discount" },
  {
    value: "aggrDiscount",
    label: "Aggr. Discount",
    key: "total_external_discount"
  },
  {
    value: "netSale",
    label: "Net Sale",
    key: "merchant_receivable_amount"
  }
];
export const DEFAULT_PRINT_DPI = 203;
